
import { defineStore } from 'pinia'
import { ref } from "vue"

export const useSessionStore = defineStore("sesion", () => {


  const schema_app = import.meta.env.VITE_APP_WEB
  const schema_app_title = import.meta.env.VITE_APP_TITLE
  const token = localStorage.getItem('user')
  const user = ref<any>({})
  const menu = ref<any>([])
  function setMenu(value: any) {
    menu.value = value
  }
  const getUser = () =>{
    const userString = localStorage.getItem('user');
    user.value = userString ? JSON.parse(userString) : null;
    return user.value
  }
  const clinicOptions = () =>{
    const temp = localStorage.getItem('clinic');
    if(temp){
      return JSON.parse(temp);

    }
    return []
  }
  const divisionOptions = () =>{
    const temp = localStorage.getItem('division');
    if(temp){
      return JSON.parse(temp)
    }
    return []
  }
  return {
    schema_app,
    schema_app_title,
    token,
    user,
    menu,
    clinicOptions,
    divisionOptions,
    getUser,
    setMenu,
  }
})